var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import ProductVariant from '../../../ProductVariant/ProductVariant';
import { transformLineItemToProductVariantProps } from '../../Cart.utils';
import * as Styled from './QbsGroup.styled';
var QbsGroup = function (_a) {
    var header = _a.header, groupItems = _a.groupItems, onQuantityUpdate = _a.onQuantityUpdate, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, props = __rest(_a, ["header", "groupItems", "onQuantityUpdate", "isLoading"]);
    return (React.createElement(Styled.QbsGroup, __assign({}, props),
        React.createElement(Styled.Header, null,
            React.createElement(Styled.HeaderTop, null,
                React.createElement(Styled.Title, null, header.title),
                header.totalQuantity && (React.createElement(Styled.ItemCount, null,
                    header.totalQuantity,
                    " Added"))),
            header.subtitle && React.createElement(Styled.Subtitle, null, header.subtitle)),
        React.createElement(Styled.GroupItems, null, groupItems.map(function (lineItem) {
            var productVariantProps = transformLineItemToProductVariantProps(lineItem, true);
            return (React.createElement(Styled.GroupItem, { key: lineItem.node.id },
                React.createElement(ProductVariant, __assign({}, productVariantProps, { onQuantityUpdate: onQuantityUpdate
                        ? function (quantity) {
                            return onQuantityUpdate(lineItem.node.id, quantity);
                        }
                        : undefined, isLoading: isLoading }))));
        }))));
};
export default QbsGroup;
